import React, { Component } from 'react'
import OneLineEditor from '../components/OneLineEditor'
import EstimationActions from '../libs/EstimationActions'
import Utils from '../libs/Utils'
import Description1 from './LaborUnitPriceTab/Description1'
import Description2 from './LaborUnitPriceTab/Description2'
import DescriptionMitsumori from './LaborUnitPriceTab/DescriptionMitsumori'
import SocialInsuranceUchiwake from './LaborUnitPriceTab/SocialInsuranceUchiwake'

class LaborUnitPricePrintTab extends Component {
  constructor (props) {
    super(props)
    this.state = {
      data: EstimationActions.getCurrentEstimation()
    }
  }
  render () {
    const inputStyle = {
      backgroundColor: 'FFFFFF',
      cursor: 'normal'
    }
    const daikuLabor = EstimationActions.getLaborSharedValues('daiku')
    let daikuLaborUnitPriceType = daikuLabor.laborUnitPriceType
    let daikuGetsugaku = daikuLabor.getsugaku

    const kaitaiLabor = EstimationActions.getLaborSharedValues('kaitai')
    let kaitaiLaborUnitPriceType = kaitaiLabor.laborUnitPriceType
    let kaitaiGetsugaku = kaitaiLabor.getsugaku

    return (
      <div>
        <article className='kw-katawaku-art kw-lobor-cost'>

          <section className='kw-print-page kw-print-page-area'>
            <div className='kw-container'>
              <h5>労務単価の計算</h5>

              <div className='kw-overview'>
                <p className='kw-pad1 kw-clear'>型枠大工の報酬月額</p>

                <div className='kw-tbl'>
                  <table>
                    <thead>
                      <tr>
                        <th className='kw-name' />
                        <th className='kw-yen' />
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th>日額手取り賃金</th>
                        <td className={this.state.isEditable && (daikuLaborUnitPriceType === 'Tedori') ? 'kw-inputable' : ''}>
                          {daikuLaborUnitPriceType === 'Tedori' ? <OneLineEditor bindingDataAttribute='daikuLaborTedoriUnitPrice' prefix='¥' isNum textAlign='right' isCommaSeparated callback={EstimationActions.updateLaborUnitPrice} />
                      : Utils.convKingaku(this.state.data.daikuLaborTedoriUnitPrice)}
                        </td>
                      </tr>
                      <tr>
                        <th>日額賃金(本人負担含む)</th>
                        <td className={this.state.isEditable && (daikuLaborUnitPriceType === 'Honnin') ? 'kw-inputable' : ''}>
                          {daikuLaborUnitPriceType === 'Honnin' ? <OneLineEditor bindingDataAttribute='daikuLaborHonninUnitPrice' prefix='¥' isNum textAlign='right' isCommaSeparated
                            callback={EstimationActions.updateLaborUnitPrice} />
                      : Utils.convKingaku(this.state.data.daikuLaborHonninUnitPrice)}
                        </td>
                      </tr>
                      <tr>
                        <th>法定福利費込み日額人件費</th>
                        <td className={this.state.isEditable && (daikuLaborUnitPriceType === 'Hukuri') ? 'kw-inputable' : ''}>
                          {daikuLaborUnitPriceType === 'Hukuri' ? <OneLineEditor bindingDataAttribute='daikuLaborHukuriUnitPrice' prefix='¥' isNum textAlign='right' isCommaSeparated
                            callback={EstimationActions.updateLaborUnitPrice} />
                      : Utils.convKingaku(this.state.data.daikuLaborHukuriUnitPrice)}
                        </td>
                      </tr>
                      <tr>
                        <th>公共工事設計労務単価</th>
                        <td className={this.state.isEditable && (daikuLaborUnitPriceType === 'Sekkei') ? 'kw-inputable' : ''}>
                          {daikuLaborUnitPriceType === 'Sekkei' ? <OneLineEditor bindingDataAttribute='daikuLaborSekkeiUnitPrice' prefix='¥' isNum textAlign='right' isCommaSeparated callback={EstimationActions.updateLaborUnitPrice} />
                      : Utils.convKingaku(this.state.data.daikuLaborSekkeiUnitPrice)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>{/* <!-- .kw-tbl --> */}
                <div className='kw-tbl2'>
                  <table>
                    <thead>
                      <tr>
                        <th className='kw-name' />
                        <th className='kw-yen' />
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th>平均労務日数</th>
                        <td className='text-right' style={inputStyle}><OneLineEditor bindingDataAttribute='daikuLaborWorkDays' isNum suffix='日' textAlign='right' /></td>
                      </tr>
                      <tr>
                        <th>労務月額</th>
                        <td>
                          {Utils.convKingaku(daikuGetsugaku)}
                        </td>
                      </tr>
                      <tr>
                        <th>標準報酬月額</th>
                        <td>{Utils.convKingaku(EstimationActions.getHyouzyunGetsugaku(daikuGetsugaku, true))}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>{/* <!-- .kw-tbl2 --> */}

                <p className='kw-pad1 kw-clear'>社会保険料内訳</p>
                <SocialInsuranceUchiwake laborType='daiku' />

              </div>{/* <!-- .kw-overview --> */}

              <div className='kw-overview'>
                <p className='kw-pad1 kw-clear'>型枠解体工の報酬月額</p>

                <div className='kw-tbl'>
                  <table>
                    <thead>
                      <tr>
                        <th className='kw-name' />
                        <th className='kw-yen' />
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th>日額手取り賃金</th>
                        <td className={this.state.isEditable && (kaitaiLaborUnitPriceType === 'Tedori') ? 'kw-inputable' : ''}>
                          {kaitaiLaborUnitPriceType === 'Tedori' ? <OneLineEditor bindingDataAttribute='kaitaiLaborTedoriUnitPrice' prefix='¥' isNum textAlign='right' isCommaSeparated callback={EstimationActions.updateLaborUnitPrice} />
                    : Utils.convKingaku(this.state.data.kaitaiLaborTedoriUnitPrice)}
                        </td>
                      </tr>
                      <tr>
                        <th>日額賃金(本人負担含む)</th>
                        <td className={this.state.isEditable && (kaitaiLaborUnitPriceType === 'Honnin') ? 'kw-inputable' : ''}>
                          {kaitaiLaborUnitPriceType === 'Honnin' ? <OneLineEditor bindingDataAttribute='kaitaiLaborHonninUnitPrice' prefix='¥' isNum textAlign='right' isCommaSeparated
                            callback={EstimationActions.updateLaborUnitPrice} />
                    : Utils.convKingaku(this.state.data.kaitaiLaborHonninUnitPrice)}
                        </td>
                      </tr>
                      <tr>
                        <th>法定福利費込み日額人件費</th>
                        <td className={this.state.isEditable && (kaitaiLaborUnitPriceType === 'Hukuri') ? 'kw-inputable' : ''}>
                          {kaitaiLaborUnitPriceType === 'Hukuri' ? <OneLineEditor bindingDataAttribute='kaitaiLaborHukuriUnitPrice' prefix='¥' isNum textAlign='right' isCommaSeparated
                            callback={EstimationActions.updateLaborUnitPrice} />
                    : Utils.convKingaku(this.state.data.kaitaiLaborHukuriUnitPrice)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>{/* <!-- .kw-tbl --> */}
                <div className='kw-tbl2'>
                  <table>
                    <thead>
                      <tr>
                        <th className='kw-name' />
                        <th className='kw-yen' />
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th>平均労務日数</th>
                        <td className='text-right' style={inputStyle}><OneLineEditor bindingDataAttribute='kaitaiLaborWorkDays' isNum suffix='日' textAlign='right' /></td>
                      </tr>
                      <tr>
                        <th>労務月額</th>
                        <td>{Utils.convKingaku(kaitaiGetsugaku)}</td>
                      </tr>
                      <tr>
                        <th>標準報酬月額</th>
                        <td>{Utils.convKingaku(EstimationActions.getHyouzyunGetsugaku(kaitaiGetsugaku, true))}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>{/* <!-- .kw-tbl2 --> */}

                <p className='kw-space7 kw-clear' />

                <p className='kw-pad1 kw-clear'>社会保険料内訳</p>
                <SocialInsuranceUchiwake laborType='kaitai' />

              </div>{/* <!-- .kw-overview --> */}

            </div>
          </section>

        </article>
        <article className='kw-katawaku-art kw-lobor-cost'>

          <section className='kw-print-page kw-print-page-area'>
            <div className='kw-container'>
              <div className='kw-overview'>
                <p className='kw-pad1 kw-clear'>用語・基礎数値の説明</p>
                <p className='kw-space3 kw-clear' />
                <Description1 estimationType={this.state.data.estimationType} />
              </div>{/* <!-- .kw-overview --> */}

              <div className='kw-overview'>
                <p className='kw-space8 kw-clear' />
                <Description2 estimationType={this.state.data.estimationType} />
              </div>{/* <!-- .kw-overview --> */}

            </div>
          </section>

        </article>
        <article className='kw-katawaku-art kw-lobor-cost'>

          <section className='kw-print-page kw-print-page-area'>
            <div className='kw-container'>
              <h5>見積条件書</h5>

              <div className='kw-overview kw-detail'>
                本見積書作成に際して見積条件を下記の通りとさせて頂きます。
                <DescriptionMitsumori estimationType={this.state.data.estimationType} />
              </div>{/* <!-- .kw-overview --> */}

            </div>
          </section>

        </article>
      </div>
    )
  }
}

export default LaborUnitPricePrintTab



// WEBPACK FOOTER //
// ./src/company_user/print/LaborUnitPricePrintTab.js